module.exports = "./img/logonuevo.png";